module.exports = __webpack_public_path__ + "static/media/5.6d30b69a.png";